var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoreInfo1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h64v64H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 26.807a2.6 2.6 0 10-2.6-2.6 2.6 2.6 0 002.6 2.6zm0 2.6a2.6 2.6 0 102.6 2.6 2.6 2.6 0 00-2.6-2.603zm0 7.789a2.6 2.6 0 102.6 2.6 2.6 2.6 0 00-2.6-2.603z",
    fill: "#006e94"
  })));
}
export default SvgMoreInfo1;